import React, { useEffect, useMemo, useState } from 'react';
import { CollapseBlock, Spinner } from '../../../common/index.jsx';
import { useTranslation } from 'react-i18next';
import { Col, Form as AntdForm, Radio, Row } from 'antd';
import { routes } from '../../../../utils/helpers/ApiClient.jsx';
import { AppBarCMS } from '../../../basic/index.jsx';
import Form from '../../../antd/form/Form/Form.jsx';
import FormButtonsContainer from '../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import FormButton from '../../../antd/form/FormButton/FormButton.jsx';
import FormSelect from '../../../antd/form/FormSelect/FormSelect.jsx';
import { required } from '../../../antd/form/FormValidation.js';
import { useGetUsersQuery } from '../../../../redux/services/users.jsx';
import { useImpersonateMutation } from '../../../../redux/services/authApi.jsx';
import { useNavigate } from 'react-router-dom';

const AccountChooser = () => {
  const { t } = useTranslation();
  const [selectedGroup, setSelectedGroup] = useState('employee');
  const [form] = AntdForm.useForm();

  const navigate = useNavigate();

  const { data: users } = useGetUsersQuery({ type: 'forAccountChooser' });
  const [impersonate] = useImpersonateMutation();

  const [formUserId, setFormUserId] = useState(undefined);

  const allUserOptions = useMemo(() => {
    if (!users) {
      return undefined;
    }

    return users.map((item) => {
      const suffix = item.account_chooser_group === 'employee'
        ? item.department_code
        : item.account_chooser_group === 'student'
          ? item.study_group
          : item.account_chooser_group === 'external' || item.account_chooser_group === 'external_partner'
            ? item.company_name
            : null;

      return {
        value: JSON.stringify({
          id: item.impersonate_id,
          type: item.impersonate_type,
        }),
        label: suffix ? `${item.full_name} (${suffix})` : item.full_name,
        group: item.account_chooser_group,
      };
    });
  }, [users]);

  const usersOptions = useMemo(() => {
    if (!allUserOptions) {
      return undefined;
    }

    return allUserOptions.filter((item) => item.group === selectedGroup);
  }, [allUserOptions, selectedGroup]);

  useEffect(() => {
    if (!usersOptions?.some((option) => option.value === formUserId)) {
      setFormUserId(undefined);
      form.setFieldsValue({ user_id: undefined });
    }
  }, [form, formUserId, usersOptions]);

  if (!usersOptions) {
    return <Spinner />;
  }

  return (
    <>
      <AppBarCMS
        title={t('Prihlásenie sa ako iný používateľ')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Administrácia')}
      />
      <div style={{ margin: '10px' }}>
        <Row>
          <Col md={{ span: 16, offset: 4 }} sm={{ span: 22, offset: 1 }}>
            <CollapseBlock>
              <Form
                form={form}
                onFinish={(values) => {
                  const selectedUser = JSON.parse(formUserId ?? values.user_id);
                  navigate(routes.cmsDashboard);
                  impersonate(selectedUser);
                }}
              >
                <Radio.Group
                  value={selectedGroup}
                  onChange={(e) => {
                    setSelectedGroup(e.target.value);
                    setFormUserId(undefined);
                    form.setFieldsValue({ user_id: undefined });
                  }}
                  style={{ marginBottom: '16px' }}
                >
                  <Radio.Button value="employee">
                    {t('Zamestnanci a doktorandi FRI')}
                  </Radio.Button>
                  <Radio.Button value="student">
                    {t('Študenti FRI')}
                  </Radio.Button>
                  <Radio.Button value="external">
                    {t('Externí používatelia')}
                  </Radio.Button>
                  <Radio.Button value="external_partner">
                    {t('Externí partneri')}
                  </Radio.Button>
                </Radio.Group>

                <FormSelect
                  label={t('Vybrať používateľa')}
                  name={'user_id'}
                  placeholder={t('Vyhľadať používateľa')}
                  options={usersOptions}
                  rules={[required(t)]}
                  value={formUserId}
                  onChange={(value) => {
                    setFormUserId(value);
                    form.setFieldsValue({ user_id: value });
                  }}
                />

                <FormButtonsContainer>
                  <FormButton submitOnClick={true}>{t('Prihlásiť')}</FormButton>
                </FormButtonsContainer>
              </Form>
            </CollapseBlock>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default AccountChooser;
